import React from "react";
import { useRouter } from "next/navigation";
import { SUPPORT_EMAIL } from "@/constant/common";

type Router = ReturnType<typeof useRouter>;

export const handleNavClick = (
  e: React.MouseEvent<HTMLAnchorElement>,
  href: string,
  pathname: string,
  router: Router,
) => {
  e.preventDefault();
  const targetId = href.substring(1);

  if (pathname === "/") {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  } else {
    router.push(`/#${targetId}`);
    setTimeout(() => {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  }
};

export const handleManageSubscriptionClick = () => {
  window.location.href = `mailto:${SUPPORT_EMAIL}`;
};
